
import React, {useEffect, useState} from 'react';
import {accommodation_total_view_count} from '../../../service/accommodation'
import rombus from '../../../media/rombus.gif'

const AccCountBlock = ({prod_type=null, date_from=null, date_to=null, title=null, sub_title=null, token, timeout=1000}) => {

    const [count_v, set_d_count] = useState(null);

    const  popd = (date_from, date_to, prod_type) => {
        const limit = 8;

        setTimeout(() => {
            accommodation_total_view_count(date_from, date_to, prod_type, token).then((d) => {
            if(d != null){
                set_d_count(d)
            }
        });
        }, (timeout));

    }
    

    let cTitle = 'Accommodation Views';
    if(title != null){
        cTitle = title;
    }

    let cSubTitle = 'Users on accommodation page';
    if(sub_title != null){
        cSubTitle = sub_title;
    }


    useEffect(() =>{
        popd(date_from, date_to, prod_type);
    }, [, date_from, date_to, prod_type])

    if(count_v == null){
        return <>
            <div className='countBlock'>
                <div className='countBlockTitle'>
                    {cTitle}
                </div>
                <div className='countBlockContent'>
                    <div style={{justifyContent: 'center'}}>
                            <img src={rombus}></img>
                    </div>
                </div>
            </div>
        </>
    }
    
    const formatted = Number(count_v).toLocaleString('en-US');

    return (<div className='countBlock'>
        <div className='countBlockTitle'>
            {cTitle}
        </div>
        <div className='countBlockContent'>
            <div className='info'>{formatted}</div>
            <div className='info infosmall'>{cSubTitle}</div>
        </div>
    </div>)

}

export default AccCountBlock
